import React, { useEffect, useState } from "react";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import ValidationButton from "../ValidationButton";
import PreviewButton from "../PreviewButton";
import { useDispatch, useSelector } from "react-redux";
import { completeTask, getTask } from "../../../store/action/taskAction";
import { BsUpload } from 'react-icons/bs';
import { createFinancialDocument } from '../../../store/action/claimManagement';
import { addMetaDataToFile, uploadFile, deleteFileImage } from '../../../store/action/fileManagement';
import { TailSpin } from "react-loader-spinner";
import { useNavigate, useParams } from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    paper: {
        borderRadius: "11px",
        width: "100%",
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    uploadSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        width: '100%',
    },
    uploadRectangle: {
        width: '100%',
        height: '600px', 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        opacity: 0.8,
        backgroundColor: 'rgba(243, 246, 249, 1);',
    },
    uploadTextPrimary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '24px',
        color: 'rgba(60, 101, 86, 1)',
        marginTop: '10px',
    },
    uploadTextSecondary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '23px',
        textAlign: 'center',
        color: 'rgba(128, 128, 143, 1)',
        marginTop: '5px',
    },
    hiddenInput: {
        display: 'none',
    },
    previewBtn: {
        position: 'absolute',
        background: 'rgb(243, 246, 249)',
        right: '-5px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
    
    deleteButton:{
     
    }
}));
const commonButtonStyle = {
    fontFamily: 'Poppins',
    fontSize: '10.76px',
    fontWeight: 600, 
    border: 'none',
    cursor: 'pointer',
    opacity: '0px',
    borderRadius: '5.38px', 
};
const annulerStyle = {
    ...commonButtonStyle,
    width: 'fit-content',
    height: '36px',
    backgroundColor: 'rgba(229, 234, 238, 1)',
    color: 'rgb(225, 31, 31)', 
    marginRight : '20px'
};
const UploadQuittance = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();

    const classes = useStyles();
    const dispatch = useDispatch();

    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const username = localStorage.getItem('username');

    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    useEffect(() => {
        const fetchTask = async () => {
            try {
                const response = await getTask(taskId, username);
                setTask(response)
                setInfoSinistre(response?.businessKey)
                setVariables(response?.variables)
                setClaimNumber(response?.businessKey)
            } catch (error) {
                console.error(`Error fetching task details: ${error.message}`);
            }
        };
        fetchTask();
    }, [dispatch, taskId, username]);

    const [variables, setVariables] = useState(task?.variables)
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
    const [claimNumber, setClaimNumber] = useState(task?.businessKey);
    const [uid, setUid] = useState('');
    const [refresh, setRefresh] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    useEffect(() => {
        if (task?.assignee === username) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
    }, [task]);

    const validateInputs = () => {
        const validationErrors = [];

        if (!uid) {
            validationErrors.push("Veuillez télécharger Votre Quittance");
        }

        return validationErrors;
    };

    const handleInvoiceValidation = async () => {
        const Quittance = {
            type: 'QUITTANCE',
            associatedClaimNumber: task.businessKey, 
            associatedDocument: uid,
            totalAmountWOTax: 0,
            totalAmountWTax: 0, 
        };

        if (task && task.variables && task.variables.claimExpertId) {
            Quittance.status = 'RECEIVED';
        } else {
            Quittance.status = 'VALID';
        }

        try {
            await dispatch(createFinancialDocument(Quittance)); 
        } catch (error) {
            console.error('Error creating financial document:', error);
        }
    };

    const ValidationAction = async () => {
        const validationErrors = validateInputs();

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        await handleInvoiceValidation();
        try {
            await dispatch(completeTask(taskId, username, variables));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error(error);
            setErrors(["Erreur lors de la validation. Veuillez réessayer."]);
            setOpenErrorDialog(true);
        }
    }

    const handleUploadClick = () => {
        document.getElementById('fileInput').click();
    };

    const handleFileChange = async (event) => {
        setLoading(true);

        const file = event.target.files[0];
        if (!file) {
            setLoading(false);
            return;
        }

        const validType = 'application/pdf';
        if (file.type !== validType) {
            toast.error("Seuls les fichiers PDF sont acceptés");
            setLoading(false);
            return;
        }

        const fileUrl = URL.createObjectURL(file);
        setPdfUrl(fileUrl);

        const formData = new FormData();
        formData.append('fileUploaded', file);
        formData.set('createdBy', username);
        formData.set('key', 'NUM_SIN');
        formData.set('value', claimNumber);
        try {
            const response = await dispatch(uploadFile(formData));

            const uid = response.uid;
            setUid(uid);

            const metaData = {
                key: 'TYPE_DOCUMENT',
                value: 'VOUCHER',
            };
            await dispatch(addMetaDataToFile(uid, metaData));
            setRefresh(!refresh);
        } catch (error) {
            console.log(error);
            toast.error("Une erreur est survenue lors de l'ajout du fichier");
        } finally {
            setLoading(false);
        }
    };
    const handleDeleteFile = async () => {
        setPdfUrl(null);
        setUid(null);
        try {
            await dispatch(deleteFileImage(uid));
            setRefresh(!refresh);
        } catch (error) {
            console.error("Error deleting file:", error);
        }
    };

    return (
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
                <div className={classes.mainContent}>
                    <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed}/>

                    <Paper className={classes.paper}>
                        <div className={classes.uploadSection} style={{ overflow: 'hidden' }}>
                            {pdfUrl ? (
                                <div className={classes.uploadRectangle}>
                                    <div className={classes.uploadTextPrimary}>
                                        Prévisualiser votre Quittance
                                    </div>
                                    {loading ? (
                                        <TailSpin color="rgba(187, 200, 8, 1)" radius={"10px"} />
                                    ) : (
                                        <div style={{ textAlign: 'center', width: '100%', overflow: 'hidden' }}>
                                            <iframe src={pdfUrl} width="100%" height="500" title="PDF Viewer" style={{ border: 'none' }}></iframe>
                                            <button 
                                            style={annulerStyle}
                                                onClick={() => {
                                                    handleDeleteFile();
                                                }}
                                            >
                                                Supprimer le fichier
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className={classes.uploadRectangle} onClick={handleUploadClick}>
                                    <BsUpload style={{ color: 'rgba(60, 101, 86, 1)' }} size={40} />
                                    <div className={classes.uploadTextPrimary}>
                                        Ajoutez votre Quittance
                                    </div>
                                    <div className={classes.uploadTextSecondary}>
                                        Déposez votre quittance{", "}
                                        <u style={{color: 'rgba(60, 101, 86, 1)'}}>parcourir</u> un fichier <br/> depuis votre
                                        ordinateur.
                                    </div>
                                    <input id="fileInput" type="file" accept="image/*,application/pdf" className={classes.hiddenInput}
                                      disabled={isTaskClaimed}   onInput={handleFileChange}/>
                                </div>
                            )}
                        </div>
                    </Paper>
                </div>
                <PreviewButton claimData={infoSinistre} />
            </div>
            <ValidationButton
                handleValidation={() => isTaskClaimed ? null : ValidationAction()}
            />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div> 
    );
};

export default UploadQuittance;
